import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CommunityProductCategoryState } from './community-product-category.reducer';

// Selector to get the "communityProductCategory" feature state
export const selectCommunityProductCategoryState = createFeatureSelector<CommunityProductCategoryState>('communityProductCategory');

// Selector to get all community Product category data
export const selectAllCommunityProductCategory = createSelector(
  selectCommunityProductCategoryState,
  (state: CommunityProductCategoryState) => state.communityProductCategory
);

// Selector to get the loading state
export const selectLoading = createSelector(
  selectCommunityProductCategoryState,
  (state: CommunityProductCategoryState) => state.loading
);
